<template>
  <b-modal
    :id="modalID"
    @shown="onShown"
    title="Choose period"
    class="modal-primary"
    @hidden="$emit('date-picker-modal-emit', changedDateFrom, changedDateTo)"
    @ok="
      $emit('date-picker-modal-emit', changedDateFrom, changedDateTo),
        fetchData()
    "
  >
    <b-form>
      <b-form-group label="From" label-for="changedDateFrom" :label-cols="3">
        <datepicker use-utc
          format="MM/dd/yyyy"
          :bootstrap-styling="true"
          v-model="changedDateFrom"
          name="changedDateFrom"
        ></datepicker>
      </b-form-group>
      <b-form-group label="To" label-for="changedDateTo" :label-cols="3">
        <datepicker use-utc
          format="MM/dd/yyyy"
          :bootstrap-styling="true"
          v-model="changedDateTo"
          name="changedDateTo"
        ></datepicker>
      </b-form-group>
    </b-form>
  </b-modal>
</template>
<script>
import Datepicker from "vuejs-datepicker";

export default {
  name: "DateModal",
  components: {
    Datepicker
  },
  props: ["fetchData", "dateFrom", "dateTo", "modalID"],
  data: function() {
    return {
      changedDateFrom: this.dateFrom,
      changedDateTo: this.dateTo
    };
  },
  methods: {
    onShown() {
      this.changedDateFrom = this.dateFrom;
      this.changedDateTo = this.dateTo;
    }
  }
};
</script>

<style scoped></style>
